function Input({type, name, placeholder, ...buttonProps}) {
    return (
        <input type={type} placeholder={placeholder} name={name} id={name} className="w-full h-[50px] text-custom-blue-darken appearance-none border px-5 rounded-md border-[#A7AAB3] outline-none transition-all" {...buttonProps} />
    )
}

export default Input
